import { render, staticRenderFns } from "./CommunicationTypeInfo.vue?vue&type=template&id=8aca9b64&"
import script from "./CommunicationTypeInfo.vue?vue&type=script&lang=js&"
export * from "./CommunicationTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports